import axios from "axios";
import { SERVER_URL } from "../config";

export const fetchfreeQtyReport = async (filters = {}) => {
  try {
    const params = { year: filters.year };

    if (filters.from && filters.to) {
      params.from = filters.from;
      params.to = filters.to;
    }

    if (filters.godown && filters.godown.length) {
      params.godown = filters.godown; // axios serializes arrays as godown[]=A&godown[]=B
    }

    const response = await axios.get(
      `${SERVER_URL}/freeQtyReport.php`,
      { params }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

// 🆕 Distinct godown list, derived server-side from bill_type
export const fetchGodownList = async () => {
  const response = await axios.get(`${SERVER_URL}/godownList.php`);
  return response.data.data || [];
};